/**
 * Entrada do staff.
 *
 * Uma conta pode servir mais do que um restaurante: quando isso acontece, o
 * ecrã pergunta qual, em vez de escolher o primeiro em silêncio como antes
 * — um gerente de duas casas ficava a gerir a errada sem perceber porquê.
 */

import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { errorMessage } from '../api/client';
import { useSessao } from '../auth/SessionContext';
import { Feedback } from '../components/ui';
import Brand from '../components/common/Brand';
import SynapraFooter from '../components/common/SynapraFooter';
import './login.css';

const LoginPage = () => {
  const { sessao, aCarregar, iniciarSessao, escolherRestaurante } = useSessao();
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState<string | null>(null);

  const solicitado = (location.state as { from?: string } | null)?.from;
  const destino = solicitado?.startsWith('/') && !solicitado.startsWith('//')
    ? solicitado
    : '/staff-mobile';

  // Já entrou e serve uma só casa: não há nada a perguntar.
  if (sessao && sessao.tenants.length === 1) {
    return <Navigate to={destino} replace />;
  }

  const submeter = async (evento: React.FormEvent) => {
    evento.preventDefault();
    setErro(null);
    try {
      await iniciarSessao(username, password);
    } catch (e) {
      setErro(errorMessage(e, 'Credenciais inválidas.'));
    }
  };

  return (
    <main className="surface login-page">
      <section className="login-story" aria-label="Bamidi"><Brand subtitle="Gelataria & creparia" /><div><p className="login-headline">O bom serviço<br />começa aqui.</p><p>A tua equipa. Os teus pedidos.<br />Tudo no mesmo lugar.</p></div><span>Espaço reservado à equipa Bamidi.</span></section>
      <section className="login-panel"><div className="login-form-card">
        <div className="login-mobile-brand"><Brand /></div>
        <h1>Bem-vindo de volta.</h1><p className="login-intro">Entra com a tua conta para começar o serviço.</p>
        <Feedback message={erro} />

        {sessao && sessao.tenants.length > 1 ? (
          <>
            <h2 className="card-title">Em que restaurante vai trabalhar?</h2>
            <div className="rows">
              {sessao.tenants.map((t) => (
                <button
                  key={t.slug}
                  type="button"
                  className="row-item"
                  style={{ textAlign: 'left', cursor: 'pointer' }}
                  onClick={() => {
                    escolherRestaurante(t.slug);
                    navigate(destino, { replace: true });
                  }}
                >
                  <div className="row-main">
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </button>
              ))}
            </div>
          </>
        ) : (
          <form
            onSubmit={submeter}
            style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
          >
            <label className="field">
              <span>Utilizador</span>
              <input
                value={username}
                name="username"
                spellCheck={false}
                autoCapitalize="none"
                autoComplete="username"
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </label>
            <label className="field">
              <span>Palavra-passe</span>
              <input
                type="password"
                value={password}
                name="password"
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>
            <button type="submit" className="btn accent" disabled={aCarregar}>
              {aCarregar ? 'A entrar…' : 'Entrar'}
            </button>
          </form>
        )}
      </div><p className="login-help">Precisas de acesso? Fala com o responsável do restaurante.</p><SynapraFooter /></section>
    </main>
  );
};

export default LoginPage;
